import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext } from 'react';
import classnames from 'classnames';
import Context from '../../context';
import { getDate, getStartOfWeek, addDays, newDate, getWeek, getMonth, isAfter, isSameMonth, getEndOfWeek, setTime } from '../../utils/date-fns';
import { getHours, getMinutes, getSeconds, isBefore, isSameDay, isSameWeek } from 'date-fns';
import useRangeCls from '../../hooks/use-range-cls';
var formatWeekNumber = function formatWeekNumber(date) {
  return getWeek(date);
};
var isDisabledTime = function isDisabledTime(value, units) {
  var _a;
  return (_a = _findInstanceProperty(units).call(units, function (n) {
    return n.value === value;
  })) === null || _a === void 0 ? void 0 : _a.disabled;
};
function Week(props) {
  var context = useContext(Context);
  var prefixCls = context.prefixCls,
    dateValue = context.dateValue,
    rangeValue = context.rangeValue,
    panelPosition = context.panelPosition,
    hoverRangedValue = context.hoverRangedValue,
    viewDate = context.viewDate,
    _context$hours = context.hours,
    hours = _context$hours === void 0 ? [] : _context$hours,
    _context$minutes = context.minutes,
    minutes = _context$minutes === void 0 ? [] : _context$minutes,
    _context$seconds = context.seconds,
    seconds = _context$seconds === void 0 ? [] : _context$seconds,
    disabledTimePanel = context.disabledTimePanel,
    onSelect = context.onSelect,
    onDateMouseEnter = context.onDateMouseEnter,
    onDateMouseLeave = context.onDateMouseLeave,
    cellRender = context.cellRender,
    range = context.range;
  var showWeekNumber = props.showWeekNumber,
    day = props.day,
    picker = props.picker,
    showTime = props.showTime,
    disabledDate = props.disabledDate;
  var currentMonth = getMonth(viewDate);
  var _dateValue;
  if (panelPosition) {
    _dateValue = rangeValue;
  } else {
    _dateValue = dateValue;
  }
  var hasFindToday = false;
  var hasFindSelected = false;
  var getSelected = function getSelected(date) {
    if (hasFindSelected) return false;
    if (Array.isArray(_dateValue)) {
      return _dateValue[0] && isSameDay(_dateValue[0], date) || _dateValue[1] && isSameDay(_dateValue[1], date);
    } else {
      if (_dateValue && isSameDay(_dateValue, date)) {
        hasFindSelected = true;
        return true;
      }
      return false;
    }
  };
  var getToday = function getToday(date) {
    if (hasFindToday) return false;
    hasFindToday = isSameDay(date, newDate());
    // 如果 today 被选中则返回 false
    if (hasFindToday) {
      if (Array.isArray(_dateValue)) {
        return !(_dateValue[0] && isSameDay(_dateValue[0], date) || _dateValue[1] && isSameDay(_dateValue[1], date));
      } else {
        return _dateValue ? !isSameDay(_dateValue, date) : true;
      }
    }
  };
  var getWeekToday = function getWeekToday(date) {
    if (hasFindToday) return false;
    hasFindToday = isSameDay(date, newDate());
    return hasFindToday;
  };
  var getWeekSelected = function getWeekSelected(date) {
    if (hasFindSelected) return false;
    if (Array.isArray(_dateValue)) {
      // 如果是 endSelected 需要判断选中的周最后一天是否为本月
      return _dateValue[0] && isSameWeek(_dateValue[0], date) || _dateValue[1] && isSameWeek(_dateValue[1], date) && isSameMonth(getEndOfWeek(_dateValue[1]), viewDate);
    } else {
      if (_dateValue && isSameWeek(_dateValue, date)) {
        hasFindSelected = true;
        return true;
      }
      return false;
    }
  };
  var getDayClassNames = function getDayClassNames(date) {
    var _classnames, _context, _context2;
    return picker === 'date' ? classnames("".concat(prefixCls, "-calendar-text"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-calendar-text-selected"), getSelected(date)), _defineProperty(_classnames, "".concat(prefixCls, "-calendar-text-today"), getToday(date)), _classnames)) : picker === 'week' ? classnames(_concatInstanceProperty(_context = "".concat(prefixCls, "-calendar-")).call(_context, picker, "-text"), _defineProperty({}, _concatInstanceProperty(_context2 = "".concat(prefixCls, "-calendar-")).call(_context2, picker, "-text-today"), getWeekToday(date))) : '';
  };
  var getRangeCls = useRangeCls({
    prefixCls: prefixCls,
    rangeValue: rangeValue,
    hoverRangedValue: hoverRangedValue,
    isRange: picker !== 'time',
    isCurrentMonth: function isCurrentMonth(date) {
      return isSameMonth(date, viewDate);
    },
    isAfterStart: function isAfterStart(date, rangedValue) {
      return rangedValue[0] ? isAfter(date, rangedValue[0]) : false;
    },
    isBeforeEnd: function isBeforeEnd(date, rangedValue) {
      return rangedValue[1] ? isBefore(date, rangedValue[1]) : false;
    },
    isStart: function isStart(date, rangedValue) {
      return rangedValue[0] ? isSameDay(date, rangedValue[0]) : false;
    },
    isEnd: function isEnd(date, rangedValue) {
      if (rangedValue[1] && isSameDay(date, rangedValue[1])) {
        if (picker === 'date') {
          return true;
        } else {
          return isSameMonth(getStartOfWeek(date), getEndOfWeek(date));
        }
      }
      return false;
    }
  });
  var getEffectTime = function getEffectTime(date) {
    if (showTime && !disabledTimePanel) {
      // debugger
      var dateHour = getHours(date);
      var dateMinute = getMinutes(date);
      var dateSecond = getSeconds(date);
      var hour = isDisabledTime(dateHour, hours) ? _findInstanceProperty(hours).call(hours, function (n) {
        return !n.disabled;
      }).value : dateHour;
      var minute = isDisabledTime(dateMinute, minutes) ? _findInstanceProperty(minutes).call(minutes, function (n) {
        return !n.disabled;
      }).value : dateMinute;
      var second = isDisabledTime(dateSecond, seconds) ? _findInstanceProperty(seconds).call(seconds, function (n) {
        return !n.disabled;
      }).value : dateSecond;
      date = setTime(date, {
        hour: hour,
        minute: minute,
        second: second
      });
    }
    return date;
  };
  var handleDayClick = function handleDayClick(day) {
    if (!(disabledDate && disabledDate(day))) {
      onSelect(day, 'mouse');
    }
  };
  var renderDays = function renderDays() {
    var _context3, _classnames4;
    var startOfWeek = getStartOfWeek(day);
    var days = [];
    var weekNumber = formatWeekNumber(startOfWeek);
    if (showWeekNumber) {
      var calenderWeekNumberCls = classnames("".concat(prefixCls, "-calendar-weeknumber"));
      days.push( /*#__PURE__*/React.createElement("div", {
        key: "W",
        className: calenderWeekNumberCls
      }, weekNumber));
    }
    var week = _concatInstanceProperty(days).call(days, _mapInstanceProperty(_context3 = [0, 1, 2, 3, 4, 5, 6]).call(_context3, function (offset) {
      var _classnames3;
      var day = addDays(startOfWeek, offset);
      var date = getDate(day);
      var now;
      if (panelPosition === 'left') {
        now = rangeValue && rangeValue[0] || viewDate;
      } else if (panelPosition === 'right') {
        now = rangeValue && rangeValue[1] || viewDate;
      } else {
        now = dateValue || viewDate;
      }
      var dayTime = setTime(day, {
        hour: getHours(now),
        minute: getMinutes(now),
        second: getSeconds(now)
      });
      var _props = {
        onClick: function onClick() {
          return handleDayClick(getEffectTime(dayTime));
        },
        onMouseEnter: function onMouseEnter() {
          if (onDateMouseEnter) {
            if (!(disabledDate && disabledDate(dayTime))) {
              picker === 'week' ? onDateMouseEnter(startOfWeek) : onDateMouseEnter(getEffectTime(dayTime));
            }
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (onDateMouseLeave) {
            onDateMouseLeave();
          }
        }
      };
      var originNode = /*#__PURE__*/React.createElement("div", {
        className: getDayClassNames(day)
      }, date);
      return /*#__PURE__*/React.createElement("div", _extends({
        key: day.valueOf(),
        className: classnames("".concat(prefixCls, "-calendar-item"), (_classnames3 = {}, _defineProperty(_classnames3, "".concat(prefixCls, "-calendar-item-disabled"), disabledDate && disabledDate(day)), _defineProperty(_classnames3, "".concat(prefixCls, "-calendar-current"), currentMonth === getMonth(day)), _classnames3), getRangeCls(day))
      }, _props), typeof cellRender === 'function' ? cellRender(day, {
        originNode: originNode,
        panelType: 'date',
        range: range,
        date: day
      }) || originNode : originNode);
    }));
    var originNode = /*#__PURE__*/React.createElement("div", {
      className: classnames((_classnames4 = {}, _defineProperty(_classnames4, "".concat(prefixCls, "-calendar-line"), picker !== 'week'), _defineProperty(_classnames4, "".concat(prefixCls, "-calendar-week-line"), picker === 'week'), _defineProperty(_classnames4, "".concat(prefixCls, "-calendar-week-selected"), picker === 'week' && getWeekSelected(startOfWeek)), _classnames4))
    }, week);
    return typeof cellRender === 'function' ? cellRender(weekNumber, {
      originNode: originNode,
      panelType: 'week',
      range: range,
      date: startOfWeek
    }) || originNode : originNode;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderDays());
}
export default Week;